(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-custom-collection-series"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var mySwiper = new Swiper('.new-custom-collection-series.swiper', {
      loop: false,
      slidesPerView: 6,
      spaceBetween: 16,
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1550: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z2-collection-cleaning-system"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.cleaningSystemSwiper')) {
      new Swiper('.cleaningSystemSwiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: {
          el: '.cleaningSystemSwiper .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.cleaning-system-next',
          prevEl: '.cleaning-system-prev',
        },
        breakpoints: {
          768: { slidesPerView: 1 },
          850: {
            slidesPerView: 1,
            spaceBetween: 24,
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z2-collection-level"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.levelSwiper')) {
      const swiper = new Swiper('.levelSwiper', {
        slidesPerView: 1.8,
        spaceBetween: 24,
        initialSlide: 0,
        pagination: {
          el: '.levelSwiper .swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: { centeredSlides: false, allowTouchMove: true },
          850: {
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: false,
          },
        },
      });

      function updateSwiper() {
        if (window.innerWidth >= 850) {
          swiper.allowTouchMove = false;
        } else {
          swiper.allowTouchMove = true;
        }
      }

      updateSwiper();

      window.addEventListener('resize', function () {
        updateSwiper();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
